import { ReactNode } from "react";
import PublicNavbar from "./PublicNavbar";
import PublicFooter from "./PublicFooter";
import { InteractiveBackground } from "./InteractiveBackground";
import SimpleChatWidget from "../chat/SimpleChatWidget";

interface PublicLayoutProps {
    children: ReactNode;
}

const PublicLayout = ({ children }: PublicLayoutProps) => {
    return (
        <div className="min-h-screen flex flex-col relative selection:bg-primary/20 bg-background" dir="rtl">
            <InteractiveBackground />

            <div className="relative z-10 flex flex-col min-h-screen">
                <PublicNavbar />
                <main className="flex-grow">
                    {children}
                </main>
                <PublicFooter />
            </div>

            {/* Floating Simple Mode Chat Widget */}
            <SimpleChatWidget />
        </div>
    );
};

export default PublicLayout;


